const loadBrowserEnv = () => {
  return window['configurationVariables'];
};

export { loadBrowserEnv };
